



















import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from '../../components/Loading.vue';
import storage from '../../utils/storage';
import moment from 'moment';
import tableModel from '../../components/table/tableModel.vue';
@Component({
  components: {
    Loading,
    tableModel,
  },
})
export default class AddBrand extends Vue {
  private user: any;
  private spinning = false;
  private dataJson: any = {};
  private tableDataJson: any = [];
  private brand: string = '';
  private columns: any = [{
      title: 'Id',
      dataIndex: 'id',
      width: '1%',
      scopedSlots: { customRender: 'id' },
    },
    {
      title: 'Brand',
      dataIndex: 'brand',
      width: '6%',
      scopedSlots: { customRender: 'brand' },
    },
    {
      title: 'Team',
      dataIndex: 'team',
      width: '6%',
      scopedSlots: { customRender: 'team' },
    },
  ];
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      this.getData();
      console.log('please login');
    } else {
     this.$router.push({
        path: '/login',
      });
    }
  }
  private async clickAdd() {
    await this.addBrand();
    this.getData();
    this.emitEmpty();
  }
  private addBrand() {
    const that = this;
    return new Promise((resolve, reject) => {
      this.spinning = true;
      const url: string = '/api/saveBrand';
      const args = {
        team: this.user.team,
        brand: this.brand.trim(),
      };
      this.axios.post(url, args).then((res) => {
        if (res && res.data.code === 10) {
          that.$message.warning(res.data.msg);
          that.spinning = false;
          resolve(false);
        } else {
          that.$message.success('Brand Added successfully');
          that.spinning = false;
          resolve(true);
        }
        resolve('');
      }).catch((err) => {
        reject(false);
      });
    });
  }
  private async getData() {
    return new Promise((resolve, reject) => {
      const that = this;
      this.spinning = true;
      const url: string = '/api/getBrand';
      const args = {
        team: this.user.team,
      };
      this.axios.post(url, args).then((res) => {
        if (res && res.data.code === 10) {
          that.$message.warning(res.data.msg);
          that.spinning = false;
          resolve(false);
        } else {
          that.tableDataJson = res.data.data;
          that.spinning = false;
          resolve(true);
        }
        resolve('');
      }).catch((err) => {
        reject(false);
      });
    });
  }
  private getCurrentStyle(current: any, today: any): any {
    const style: any = {};
    if (current.date() === 1) {
      style.border = '1px solid #1890ff';
      style.borderRadius = '50%';
    }
    return style;
  }
  private emitEmpty() {
    const inputBox: HTMLInputElement = this.$refs.BrandInput as HTMLInputElement;
    inputBox.focus();
    this.brand = '';
  }

}
